export enum CerrixInviteType {
    Default = 0,
    CerrixForm = 1
}
